import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import VideoPageView from './components/VideoPageView';
import LandingPage from './components/LandingPage';

export const config = {
  endpoint:`https://15423533-d774-4ed5-944b-8cc65ea8f0b2.mock.pstmn.io/v1`
};

function App() {
  return (
    <div className="App">
      <React.StrictMode>
        <Router>
          <Switch>
            <Route exact path="/" component={LandingPage} />
            <Route path="/video/:id" component={VideoPageView} />
          </Switch>
        </Router>
      </React.StrictMode>
    </div>
  );
}

export default App;
